import { useMemo } from 'react';
export var useEnvironment = function (stand) {
    if (stand === void 0) { stand = 'dev'; }
    var isDev = useMemo(function () { return ['dev', 'stage', 'DEV', 'STAGE'].includes(stand); }, [stand]);
    var isProd = useMemo(function () { return ['prod', 'PROD'].includes(stand); }, [stand]);
    return { stand: stand, isDev: isDev, isProd: isProd };
};
//# sourceMappingURL=useEnvironment.js.map